import { create } from "zustand";
import { api } from "./api";
import { pushHist } from "./hist";

export const useMarket = create((set, get) => ({
  ticks: {},
  meta: {},
  status: null,
  wsState: "connecting",
  latency: [],
  tickRate: 0,
  focusKey: null,
  order: null,
  searchOpen: false,
  depthKey: null,
  portfolioVersion: 0,
  mergeTicks: (arr) => set((s) => {
    const next = { ...s.ticks };
    for (const t of arr) { next[t.k] = { ...(next[t.k] || {}), ...t, prevLtp: next[t.k]?.ltp }; pushHist(t.k, t.ltp); }
    return { ticks: next };
  }),
  addMeta: (m) => set((s) => ({ meta: { ...s.meta, ...m } })),
  setStatus: (status) => set({ status }),
  setWsState: (wsState) => set({ wsState }),
  addLatency: (ms) => set((s) => ({ latency: [...s.latency.slice(-39), ms] })),
  setTickRate: (tickRate) => set({ tickRate }),
  setFocus: (focusKey) => set({ focusKey }),
  openOrder: (o) => set({ order: o }),
  closeOrder: () => set({ order: null }),
  setSearch: (searchOpen) => set({ searchOpen }),
  setDepth: (depthKey) => set({ depthKey }),
  bumpPortfolio: () => set((s) => ({ portfolioVersion: s.portfolioVersion + 1 })),
}));

const pending = new Set();
let metaTimer = null;

export function requestMeta(keys) {
  const { meta } = useMarket.getState();
  keys.forEach((k) => { if (k && !meta[k]) pending.add(k); });
  if (!pending.size || metaTimer) return;
  metaTimer = setTimeout(async () => {
    const batch = [...pending];
    pending.clear();
    metaTimer = null;
    try {
      const { data } = await api.post("/instruments/bulk", batch);
      useMarket.getState().addMeta(data);
    } catch (e) { /* retried on next request */ }
  }, 60);
}
